import { render, staticRenderFns } from "./pagebarContainer.vue?vue&type=template&id=038e6522&scoped=true&"
import script from "./pagebarContainer.vue?vue&type=script&lang=js&"
export * from "./pagebarContainer.vue?vue&type=script&lang=js&"
import style0 from "./pagebarContainer.vue?vue&type=style&index=0&id=038e6522&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038e6522",
  null
  
)

export default component.exports